import { Card, Col, Row } from 'react-bootstrap';
import type { LeadCloudFileType } from '@econtractor/types';
import SolarFolder2BoldDuotone from 'components/icons/SolarFolder2BoldDuotone';
import ItemDropdown from './ItemDropdown';
import type { FilesViewMode } from './model/filesView';

interface FoldersListProps {
    folders: LeadCloudFileType[];
    view: FilesViewMode;
    canDelete?: boolean;
    deletingKey?: string | null;
    onOpen: (folder: LeadCloudFileType) => void;
    onDelete?: (folder: LeadCloudFileType) => void;
}

const FoldersList = ({ folders, view, canDelete, deletingKey, onOpen, onDelete }: FoldersListProps) => {
    if (!folders.length) return null;

    const colProps = view === 'list' ? { xs: 12 } : { xs: 12, sm: 6 };

    return (
        <Row>
            {folders.map((folder) => (
                <Col key={folder.storageKey || folder.folderPath} className="p-1" {...colProps}>
                    <Card className="file-card m-0">
                        <Card.Body className="p-2 file-card-body file-card-body--folder">
                            <button
                                type="button"
                                className="btn btn-link text-decoration-none text-body p-0 flex-shrink-0"
                                onClick={() => onOpen(folder)}
                                title={folder.fileName}
                            >
                                <SolarFolder2BoldDuotone className="file-folder-icon" />
                            </button>
                            <button
                                type="button"
                                className="btn btn-link text-decoration-none text-body p-0 file-card-meta d-flex align-items-center min-w-0"
                                onClick={() => onOpen(folder)}
                                title={folder.fileName}
                            >
                                <h5 className="mb-0 d-grid min-w-0">
                                    <span className="text-truncate w-100 fs-14 fw-normal no-select">
                                        {folder.fileName}
                                    </span>
                                </h5>
                            </button>
                            <ItemDropdown
                                canDelete={canDelete}
                                deleting={deletingKey === folder.storageKey}
                                onDelete={() => onDelete?.(folder)}
                            />
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

export default FoldersList;
